export const ERRORS = {
	'/pallets/input': {
		DUPLICATE_TRANSACTION: {
			error: 'inventory_transactions',
			message: 'Você não pode registrar a mesma caixa 2 vezes',
		},
	},
};
